(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    window.PXUTheme.theme_settings.cart_action_type === 'ajax' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    window.PXUTheme.cartDrawer.loadDrawer(true);
  });

  document.addEventListener('product-form:message:success', (event) => {
    event.preventDefault();
  });

  document.addEventListener('product-form:cart:update', (event) => {
    const { item_count } = event.detail.cart;
    window.PXUTheme.cartDrawer.updateCartCount(item_count);
  });

  } catch(e) { console.error(e); }
})();
})();
